import TagManager from 'react-gtm-module';

import { SexAtBirth } from 'models/user.types';

import { MailingAddress } from 'models/user.types';

type GtmUserPayload = {
  _id?: string;
  dob?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  mailingAddress?: MailingAddress;
  phoneNumber?: string;
  sexAtBirth?: string;
};

type GtmOrderPayload = {
  couponCode?: string;
  orderId?: string;
  orderTotal?: string | number;
  orderTs?: string;
  productId?: string;
  productName?: string;
};

const SEX_AT_BIRTH_LABELS: Record<SexAtBirth, string> = {
  [SexAtBirth.Female]: 'Female',
  [SexAtBirth.Male]: 'Male',
  [SexAtBirth.Other]: 'Other',
  [SexAtBirth.Unknown]: 'Unknown'
};

const mapSexAtBirth = (sexAtBirth: unknown): string => {
  if (sexAtBirth == null) return '';

  const code = String(sexAtBirth) as SexAtBirth;
  return SEX_AT_BIRTH_LABELS[code] ?? String(sexAtBirth);
};

const pushToDataLayer = (payload: Record<string, unknown>) => {
  try {
    TagManager.dataLayer({
      dataLayer: payload
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export const initTagManager = () => {
  const gtmId = import.meta.env.VITE_GTM_ID;
  if (!gtmId) return;

  try {
    TagManager.initialize({ gtmId });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn((e as Error).message);
  }
};

export function createGtmEvent(
  event: string,
  user: GtmUserPayload,
  order: GtmOrderPayload | null = {}
) {
  const mailingAddress = user.mailingAddress;
  const orderDetails = order ?? {};

  pushToDataLayer({
    current_event_ts: new Date().toISOString(),
    customer_birth_date: user.dob,
    customer_email: user.email,
    customer_first_name: user.firstName,
    customer_gender: mapSexAtBirth(user.sexAtBirth),
    customer_last_name: user.lastName,
    customer_phone: user.phoneNumber,
    customer_shipping_address1: mailingAddress?.address,
    customer_shipping_address2: mailingAddress?.address2 || '',
    customer_shipping_city: mailingAddress?.city,
    customer_shipping_state: mailingAddress?.state,
    customer_shipping_zip: mailingAddress?.zipCode,
    // event details
    event,
    // order and product details
    order_coupon_code: orderDetails.couponCode || '',
    order_currency: 'USD',
    order_id: orderDetails.orderId || '',
    order_total: orderDetails.orderTotal || '',
    order_ts: orderDetails.orderTs || '',
    // patient/customer details
    patient_id: user._id,
    product_brand: 'LifeMD',
    product_category: 'Membership',
    product_id: orderDetails.productId || '',
    product_name: orderDetails.productName || '',
    product_quantity: 1
  });
}

export const handleGTMEvent = (payload: Record<string, unknown>) => {
  pushToDataLayer(payload);
};
